// extracted by mini-css-extract-plugin
export default {"arrow":"header_arrow__IGVjo","rotated":"header_rotated__c8IpT"};